<template>
  <span class="at-wrap" :class="`at--${position}`">
    <span class="at-slot" :class="{ 'at-slot--truncate': truncate }"><slot /></span>
    <span class="at-box" :style="minWidth ? { minWidth, whiteSpace: 'normal', wordBreak: 'break-word' } : {}">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: 'AppTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top',
      validator: v => ['top', 'bottom', 'left', 'right'].includes(v)
    },
    truncate: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
/* ── Wrapper ── */
.at-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}

/* ── Slot (trigger content) ── */
.at-slot {
  flex: 1;
  min-width: 0;
}
.at-slot--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Tooltip box ── */
.at-box {
  position: absolute;
  z-index: 9999;
  background: #232627;
  color: #f8fafc;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
  padding: 5px 10px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: 0.2px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

/* ── Arrow ── */
.at-box::before {
  content: '';
  position: absolute;
  border: 5px solid transparent;
}

/* ── Top (default) ── */
.at--top .at-box {
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
}
.at--top .at-box::before {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-top-color: #232627;
}

/* ── Bottom ── */
.at--bottom .at-box {
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(-4px);
}
.at--bottom .at-box::before {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-bottom-color: #232627;
}

/* ── Left ── */
.at--left .at-box {
  right: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%) translateX(4px);
}
.at--left .at-box::before {
  left: 100%;
  top: 50%;
  margin-top: -5px;
  border-left-color: #232627;
}

/* ── Right ── */
.at--right .at-box {
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%) translateX(-4px);
}
.at--right .at-box::before {
  right: 100%;
  top: 50%;
  margin-top: -5px;
  border-right-color: #232627;
}

/* ── Show on hover ── */
.at-wrap:hover .at-box                { opacity: 1; }
.at--top.at-wrap:hover    .at-box     { transform: translateX(-50%) translateY(0); }
.at--bottom.at-wrap:hover .at-box     { transform: translateX(-50%) translateY(0); }
.at--left.at-wrap:hover   .at-box     { transform: translateY(-50%) translateX(0); }
.at--right.at-wrap:hover  .at-box     { transform: translateY(-50%) translateX(0); }
</style>
